module.exports = __webpack_public_path__ + "images/737fbc4839ac3a84eb4fc2c298638d20e12cec0f3f2a9781404d137aff03e367.svg";